export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7072';
export const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5173/';

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const UNLAYER_PROJECT_ID = Number(import.meta.env.VITE_UNLAYER_PROJECT_ID) || undefined;
export const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const MAP_BOX_KEY = import.meta.env.VITE_MAP_BOX_KEY;

export const PAYFAST_URL = import.meta.env.VITE_PAYFAST_URL || '';
export const PAYFAST_MERCHANT_ID = import.meta.env.VITE_PAYFAST_MERCHANT_ID || '';
export const PAYFAST_MERCHANT_KEY = import.meta.env.VITE_PAYFAST_MERCHANT_KEY || '';
export const PAYFAST_PASSPHRASE = import.meta.env.VITE_PAYFAST_PASSPHRASE || '';

export const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === 'true';
export const ALLOW_ONLY_ADMIN_LOGIN = import.meta.env.VITE_ALLOW_ONLY_ADMIN_LOGIN === 'true';
export const ENABLE_ANALYTICS = import.meta.env.VITE_ENABLE_ANALYTICS === 'true';

// API pagination constants
export const MAX_DROPDOWN_PAGE_SIZE = 99999; // Used for fetching all records in dropdowns/select lists